import { URL, handleErrors } from "./depannageActions"
import { getParams } from "../../utilities/Addons"
import { catchApiError } from "./apiHelpers"

export const FETCH_ENCAISSEMENTSV2_BEGIN = "FETCH_ENCAISSEMENTSV2_BEGIN"
export const FETCH_ENCAISSEMENTSV2_SUCCESS = "FETCH_ENCAISSEMENTSV2_SUCCESS"
export const FETCH_ENCAISSEMENTSV2_ERROR = "FETCH_ENCAISSEMENTSV2_ERROR"

export const DATER_ENCAISSEMENTSV2_BEGIN = "DATER_ENCAISSEMENTSV2_BEGIN"
export const DATER_ENCAISSEMENTSV2_SUCCESS = "DATER_ENCAISSEMENTSV2_SUCCESS"
export const DATER_ENCAISSEMENTSV2_ERROR = "DATER_ENCAISSEMENTSV2_ERROR"
export const DATER_ENCAISSEMENTSV2_RESET = "DATER_ENCAISSEMENTSV2_RESET"

export const fetchEncaissementsV2Begin = () => ({
	type: FETCH_ENCAISSEMENTSV2_BEGIN,
})

export const fetchEncaissementsV2Success = (payload) => ({
	type: FETCH_ENCAISSEMENTSV2_SUCCESS,
	payload,
})

export const fetchEncaissementsV2Error = (error) => ({
	type: FETCH_ENCAISSEMENTSV2_ERROR,
	payload: error,
})

export const daterEncaissementsV2Begin = () => ({
	type: DATER_ENCAISSEMENTSV2_BEGIN,
})

export const daterEncaissementsV2Success = (payload) => ({
	type: DATER_ENCAISSEMENTSV2_SUCCESS,
	payload,
})

export const daterEncaissementsV2Error = (error) => ({
	type: DATER_ENCAISSEMENTSV2_ERROR,
	payload: error,
})

export const daterEncaissementsV2Reset = () => ({
	type: DATER_ENCAISSEMENTSV2_RESET,
})

// Liste des TransactionV2 non datées (= pas encore encaissées), filtrable par
// type de fiche / payé par / moyen de paiement / recherche texte.
export function fetchEncaissementsV2(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchEncaissementsV2Begin())
		return fetch(`${URL}api/encaissementsv2${getParams(kwargs)}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchEncaissementsV2Success(json))
			})
			.catch(catchApiError(dispatch, fetchEncaissementsV2Error))
	}
}

// Datation en masse : pose la date (= encaissement) sur la sélection. Le back
// re-filtre les non datées et renvoie {updated, skipped} — une transaction
// encaissée entre-temps n'est jamais ré-écrasée.
export function daterEncaissementsV2(transactionIds, date) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(daterEncaissementsV2Begin())
		return fetch(`${URL}api/encaissementsv2`, {
			method: "PUT",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ transaction_ids: transactionIds, date }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(daterEncaissementsV2Success(json))
			})
			.catch(catchApiError(dispatch, daterEncaissementsV2Error, { silent: true }))
	}
}
